// @flow

import { delay } from 'redux-saga';
import { takeLatest, takeEvery, call, put, select } from 'redux-saga/effects';
import {
  FETCH_THREADS,
  FETCH_THREADS_SUCCESS,
  FETCH_THREADS_FAILURE,
  FILTER_THREADS_SEARCH,
  FILTER_THREADS_UNREAD,
  FILTER_THREADS_TRACKED,
  FILTER_THREADS_SUCCESS,
  FILTER_THREADS_FAILURE,
  FILTER_THREADS_SEARCH_THROTTLE,
  TRACK_THREAD,
  TRACK_THREAD_FAILURE,
  TRACK_THREAD_SUCCESS,
  READ_THREAD,
  READ_THREAD_SUCCESS,
  READ_THREAD_FAILURE,
  CREATE_THREAD_SUCCESS,
  CREATE_THREAD,
} from '../actions/threads';
import { getFilter } from '../reducers/threads';
import { normalize } from 'normalizr';
import * as ThreadsApi from '../api/threads';
import * as Schema from '../api/schema';
import { push } from 'react-router-redux';

function* fetchThreads() {
  try {
    const threads = yield call(ThreadsApi.fetchThreads, {});

    yield put({
      type: FETCH_THREADS_SUCCESS,
      response: normalize(threads, Schema.threads),
    });
  } catch (error) {
    yield put({
      type: FETCH_THREADS_FAILURE,
      error,
    });
  }
}

function* createThread({ thread }) {
  yield put({
    type: CREATE_THREAD_SUCCESS,
    thread,
  });

  yield put(push(`/threads/${thread.id}/messages`));
}

function* filterThreads() {
  try {
    const filter = yield select(getFilter);
    const threads = yield call(ThreadsApi.fetchThreads, filter);

    yield put({
      type: FILTER_THREADS_SUCCESS,
      response: normalize(threads, Schema.threads),
    });
  } catch (error) {
    yield put({
      type: FILTER_THREADS_FAILURE,
      error,
    });
  }
}

function* throttleFilterThreads() {
  yield call(delay, 500);
  yield put({
    type: FILTER_THREADS_SEARCH_THROTTLE,
  });
  yield call(filterThreads);
}

function* trackThread({ thread, value }) {
  try {
    yield call(ThreadsApi.trackThread, { thread, value });

    yield put({
      type: TRACK_THREAD_SUCCESS,
      thread,
      value,
    });
  } catch (error) {
    yield put({
      type: TRACK_THREAD_FAILURE,
      thread,
      error,
    });
  }
}

function* readThread({ thread, upToIndex }) {
  try {
    const updated = yield call(ThreadsApi.readThread, { thread, upToIndex });

    yield put({
      type: READ_THREAD_SUCCESS,
      response: normalize(updated, Schema.thread),
    });
  } catch (error) {
    yield put({
      type: READ_THREAD_FAILURE,
      thread,
      error,
    });
  }
}

export default function* root() {
  yield [
    takeLatest(FETCH_THREADS, fetchThreads),
    takeEvery(CREATE_THREAD, createThread),
    takeEvery(FILTER_THREADS_UNREAD, filterThreads),
    takeEvery(FILTER_THREADS_TRACKED, filterThreads),
    takeLatest(FILTER_THREADS_SEARCH, throttleFilterThreads),
    takeLatest(READ_THREAD, readThread),
    takeEvery(TRACK_THREAD, trackThread),
  ];
}



// WEBPACK FOOTER //
// ./src/modules/messaging/sagas/threads.js